import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { CALENDAR_URL } from '../constants/contact';

/**
 * La barra va `fixed`, no `sticky`.
 *
 * Los tres ancestros de este componente recortan overflow —el wrapper de
 * `App`, `#root` y `body`, todos con `overflow-x: hidden`— y cualquiera de
 * ellos convierte a su elemento en contenedor de scroll, lo que deja
 * `position: sticky` sin nada contra qué pegarse. Esos recortes existen para
 * contener las ilustraciones que se salen del contenedor a propósito
 * (`circle3.svg` en `-left-[120px]`, `pear3.svg`, `large-pear.svg`), así que
 * sacar la barra del flujo sale mucho más barato que destaparlos.
 *
 * El alto es explícito en vez de derivarse del padding porque hay que
 * reservarlo dos veces: en la barra y en el espaciador que evita que el hero
 * arranque por debajo de ella.
 *
 * Queda escrito de dos formas —`h-[68px]` en el markup y esta constante en el
 * espaciador— porque el JIT de Tailwind sólo genera la clase si encuentra el
 * literal en el código; una clase interpolada no existiría en el CSS. Si
 * cambia el alto, hay que cambiar los dos.
 */
const BAR_HEIGHT = 68;

const Header = () => {

  const [navBar, setnavBar] = useState("translate-x-full");
  const { t } = useTranslation();

  return (
    <>
    {/* Fondo casi opaco en vez de `backdrop-blur`: la landing ya usa
        `backdrop-blur-xl` en cada `.landingCard`, y sumar una capa fija de
        ancho completo que vuelve a desenfocar el fondo en cada frame de
        scroll congela el render en páginas largas. Sobre un fondo negro el
        blur no aporta casi nada visualmente; la opacidad sola separa igual la
        barra del contenido. */}
    <div className="fixed top-0 left-0 right-0 z-50 w-full h-[68px] bg-black/90 border-b border-white/10">
    <div className="mainCont h-full flex items-center justify-between gap-5">
      <a href="#" className="flex w-fit"><img src="/images/logo.svg" alt="logo" className="w-[170px]" /></a>
      <div className={`flex items-start lg2:items-center flex-col lg2:flex-row text-[15px] gap-7 fixed top-0 right-0 lg2:relative lg2:top-auto lg2:left-auto px-4 pt-16 pb-5 lg2:px-0 lg2:pb-0 lg2:pt-0 bg-black lg2:bg-transparent h-screen lg2:h-auto max-h-screen overflow-y-auto border-l-none sm2:border-l-[3px] border-main lg2:border-none w-full sm2:w-[300px] lg2:w-auto z-[9999999] transition lg2:transition-none lg2:translate-x-0 ${navBar}`}>
        <a href="#stablecoins" onClick={()=> {setnavBar("translate-x-full")}} className="text-white transition hover:text-main font-[500]">{t('nav.stablecoins')}</a>
        <a href="#what-we-do" onClick={()=> {setnavBar("translate-x-full")}} className="text-white transition hover:text-main font-[500]">{t('nav.whatWeDo')}</a>
        <a href="#ai-consulting" onClick={()=> {setnavBar("translate-x-full")}} className="text-white transition hover:text-main font-[500]">{t('nav.ai')}</a>
        <a href="#who-we-help" onClick={()=> {setnavBar("translate-x-full")}} className="text-white transition hover:text-main font-[500]">{t('nav.whoWeHelp')}</a>
        <a href="#why-paltalabs" onClick={()=> {setnavBar("translate-x-full")}} className="text-white transition hover:text-main font-[500]">{t('nav.why')}</a>
        <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" onClick={()=> {setnavBar("translate-x-full")}} className="bg-main transition hover:bg-main-hover text-black font-extrabold rounded-full px-5 py-2">{t('nav.contact')}</a>
        <button onClick={()=> {setnavBar("translate-x-full")}} className="flex lg2:hidden items-center justify-center absolute top-3 right-3"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#24D906" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg></button>
      </div>
      <LanguageSwitcher />
      <button onClick={()=> {setnavBar("translate-x-0")}} className="flex items-center justify-center lg2:hidden"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#24D906" viewBox="0 0 16 16"><path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/></svg></button>
    </div>
    <div onClick={()=> {setnavBar("translate-x-full")}} className={`flex lg2:hidden fixed top-0 left-0 min-h-screen min-w-full bg-white bg-opacity-30 transition z-[60] ${navBar === "translate-x-full" ? "opacity-0 invisible" : "opacity-100 visible"}`}></div>
    </div>

    {/* La barra salió del flujo, así que este bloque ocupa su lugar. Sin él el
        hero arranca tapado por ella. */}
    <div aria-hidden="true" style={{ height: BAR_HEIGHT }} />
    </>
  )
}

export default Header